import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{html-safe this.translatedText}}",{ moduleName: "discourse/components/discourse-linked-text.hbs" })